"use client"

import { useState } from "react"
import { AppointmentCard, Appointment } from "./appointment-card"

type AppointmentCardsProps = {
  appointments: Appointment[]
  onBook: (source?: string) => void
  className?: string
}

export function AppointmentCards({ appointments, onBook, className }: AppointmentCardsProps) {
  const [flippedByIndex, setFlippedByIndex] = useState<Record<number, boolean>>({})

  const setFlipped = (index: number, value: boolean) => {
    setFlippedByIndex((prev) => ({ ...prev, [index]: value }))
  }

  // Determine grid columns based on number of appointments
  const getGridCols = () => {
    const count = appointments.length
    if (count === 3) {
      return "grid-cols-1 md:grid-cols-3"
    } else if (count === 4) {
      return "grid-cols-1 md:grid-cols-2"
    } else if (count === 5) {
      return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
    } else {
      // Default: 2 columns for md+, 1 for mobile
      return "grid-cols-1 md:grid-cols-2"
    }
  }

  // Adjust max-width based on number of columns
  const getMaxWidth = () => {
    const count = appointments.length
    if (count === 3) {
      return "max-w-6xl"
    } else if (count === 5) {
      return "max-w-6xl"
    } else {
      return "max-w-3xl"
    }
  }

  const defaultClassName = `grid ${getGridCols()} gap-6 lg:gap-8 ${getMaxWidth()} mx-auto place-items-center md:place-items-stretch justify-center w-full`

  if (!appointments || appointments.length === 0) {
    return <div className="text-center text-gray-500 py-8">No appointments available</div>
  }

  return (
    <div className={className || defaultClassName}>
      {appointments.map((appt, index) => (
        <AppointmentCard
          key={`${appt.section}-${appt.title}`}
          appointment={appt}
          index={index}
          isFlipped={flippedByIndex[index] || false}
          onFlip={setFlipped}
          onBook={onBook}
        />
      ))}
    </div>
  )
}

